import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom';

function AppBar() {

    const [theme, setTheme] = useState('system');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('theme');
    if (saved) setTheme(saved);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'system') {
      root.removeAttribute('data-theme');
    } else {
      root.setAttribute('data-theme', theme);
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev =>
      prev === 'light' ? 'dark' : prev === 'dark' ? 'system' : 'light'
    );
  };

  return (
    <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-logo">🍕 PizzaApp</div>

          {/* Desktop Nav */}
          <ul className={`nav-list ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(false)}>
            <li><NavLink to={'/'} end className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>Bestellen</NavLink></li>
            <li><NavLink to={'/status'} className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>Status</NavLink></li>
            <li><NavLink to={'/manage'} className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>Verwalten</NavLink></li>
          </ul>

          {/* Theme + Hamburger */}
          <div className="navbar-actions">
            <button className="theme-toggle" onClick={toggleTheme}>
              {theme === 'light' ? '🌞' : theme === 'dark' ? '🌙' : '🖥️'}
            </button>
            <button
              className={`hamburger ${menuOpen ? 'open' : ''}`}
              onClick={(e) => {e.stopPropagation(); setMenuOpen(!menuOpen)}} // e.stopPropagation()
            >
              ☰
            </button>
          </div>
        </div>
      </nav>
  )
}

export default AppBar